import React from "react";
import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from "recharts";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { GrcCard, ragColor } from "./shared";

export const ComplianceScoreGauge = ({ score, rag, band, trendDelta, trendDirection }) => {
  const color = ragColor(rag || "YELLOW");
  const val = score ?? 0;
  const TrendIcon = trendDirection === "up" ? TrendingUp : trendDirection === "down" ? TrendingDown : Minus;
  const trendColor =
    trendDirection === "up" ? "text-[#388E3C]" : trendDirection === "down" ? "text-[#D32F2F]" : "text-slate-500";
  return (
    <GrcCard
      title="Overall Compliance Score"
      info="Weighted compliance score across all 15 pillars (Formula-1, V2.2). Trend compares the two most recent snapshots."
      infoTestId="info-compliance-score"
      testId="card-compliance-score"
    >
      <div className="relative h-36">
        <ResponsiveContainer width="100%" height="100%" minWidth={100} minHeight={100}>
          <RadialBarChart
            innerRadius="75%"
            outerRadius="100%"
            data={[{ value: val }]}
            startAngle={210}
            endAngle={-30}
          >
            <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
            <RadialBar dataKey="value" cornerRadius={8} fill={color} background={{ fill: "#EEF2F7" }} />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span data-testid="compliance-score-value" className="text-3xl font-bold text-[#003366]">
            {score != null ? `${score}%` : "—"}
          </span>
          <span className="text-[11px] text-slate-500">of 100</span>
        </div>
      </div>
      <div className="mt-1 flex items-center justify-center gap-2 text-xs">
        {band && (
          <span className="font-medium" style={{ color }} data-testid="compliance-score-band">
            {band}
          </span>
        )}
        {trendDelta != null && trendDelta !== 0 && (
          <span className={`flex items-center gap-1 font-medium ${trendColor}`} data-testid="compliance-score-trend">
            <TrendIcon size={13} />
            {trendDelta > 0 ? "+" : ""}
            {trendDelta}% vs last snapshot
          </span>
        )}
      </div>
    </GrcCard>
  );
};
